/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Multideck_Locked_RoundsInputs */



/**
* | output |
* | --- |
* | "Multideck cannot change once a round has been played" |
*
* @param {Err_Tournament_Multideck_Locked_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_multideck_locked_rounds = /** @type {((inputs?: Err_Tournament_Multideck_Locked_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Multideck_Locked_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le multi-deck ne peut plus changer une fois une ronde jouée")
	if (locale === "es") return /** @type {LocalizedString} */ ("El multideck no puede cambiar una vez jugada una ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Multideck não pode mudar depois de uma rodada jogada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il multideck non può cambiare una volta giocato un round")
	return /** @type {LocalizedString} */ ("Multideck cannot change once a round has been played")
});